import Icons_Repository from '../Icons/Icons_Repository';
import type { SelectedSlotWithContext } from '../Pages/Candidate_Page1';
import { CancelInterviewSlot, CancelInterviewSlotExp, sendCancelEmail } from '../Requests/Cancel_Slot';
import { rescheduleInterviewSlot, sendRescheduleEmail } from '../Requests/Reschedule_Slot';
import './Component_Reschedule_Cancel_Popup.css';
import { useState, useEffect, JSX } from 'react';
import { clearPairingsCache, getInterviewPairings } from '../Requests/Get_Interview_Pairings';
import { sendNoAlternateSlotsEmail } from '../Requests/sendNoAlternateSlotsEmail';
import { getInterviewPairingsExp } from '../Requests/Get_Interview_Pairings_Exp';
import { rescheduleInterviewSlotPanel, sendPanelRescheduleEmail } from '../Requests/Reschedule_Slot_Panel';
import { getInterviewPairingsPanel } from '../Requests/Get_Interview_Pairings_Panel';

interface CandidateInterviewSlotProps {
  slot: any | null;
  candidateEmail: string;
  setSelectedPage: (page: string) => void;
  setSelectedDates: (date: Date[]) => void;
  setSelectedSlot: (slot: SelectedSlotWithContext | null) => void;
  refreshPairings: (forceSubmissionGroup?: string) => void;
  setShowReschedulePopup: (val: boolean) => void;
  setCancelledInterview: (val: boolean) => void;
  setIsRescheduledClicked: (val: boolean) => void;
  isExperienced: boolean;
  isCampus: boolean;
  noAlternateRescheduleSlots: boolean;
  setnoAlternateRescheduleSlots: (val: boolean) => void;
  reschedulingReason:string;
  setReschedulingReason: (reason: string) => void;
  isPanel?: boolean; 
}

function Component_Reschedule_Cancel_Popup({
  slot,
  candidateEmail,
  setSelectedPage,
  setSelectedDates,
  setSelectedSlot,
  refreshPairings,
  setShowReschedulePopup,
  setCancelledInterview,
  setIsRescheduledClicked,
  isExperienced,
  isCampus,
  noAlternateRescheduleSlots,
  setnoAlternateRescheduleSlots,
  reschedulingReason, 
  setReschedulingReason,
  isPanel = false,
}: CandidateInterviewSlotProps) {
  const [loadingReschedule, setLoadingReschedule] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(true);
  // const [reason, setReason] = useState("");
  const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        setIsRefreshing(true);
        console.log('Reschedule popup opened with slot:', slot);
        console.log('Is experienced:', isExperienced);
        console.log('Submission group ID:', slot?.submission_group_id);

        clearPairingsCache();
        await refreshPairings();

        // Check for alternate slots based on candidate type
        if (isPanel) {
          console.log("Panel candidate - checking alternate slots");
          const data = await getInterviewPairingsPanel(true);
          const hasAvailableSlots = data?.pairings?.some((p: any) => p.slot_available === true);
          if (!hasAvailableSlots) {
            setnoAlternateRescheduleSlots(true);
          }
        } else if (isExperienced && slot?.submission_group_id) {
          console.log("Experienced candidate - checking other stage slots");
          // For experienced: check if THIS STAGE has alternate slots
          const data = await getInterviewPairingsExp(true);
          const currentStageData = data?.find(group => 
            group.pairings[0]?.submission_group_id === slot.submission_group_id
          );

          const hasAvailableSlots = currentStageData?.pairings?.some(p => p.slot_available === true);

          if (!currentStageData || !hasAvailableSlots) {
            console.log('No other slots for this stage');
            setnoAlternateRescheduleSlots(true);
          } else {
            console.log('Other slots present for this stage');
          }
        } else {
          console.log("Campus hire - checking other overall slots");
          // For campus: check overall slots
          const data = await getInterviewPairings(candidateEmail, true);

          if (data && Array.isArray(data.pairings) && data.pairings.length === 0) {
            console.log('No other slots');
            setnoAlternateRescheduleSlots(true);
          } else {
            console.log('Other slots present');
          }
        }
      } catch (error) {
        console.error('Error during initial popup load:', error);
      } finally {
        setIsRefreshing(false);
      }
    };

  fetchAllData();
}, [candidateEmail, isExperienced, slot?.submission_group_id]);

  const getAbbreviation = () => {
    try {
      const abbr = new Date()
        .toLocaleTimeString('en-us', {
          timeZone: browserTimeZone,
          timeZoneName: 'short',
        })
        .split(' ')
        .pop();

      if (abbr && /^[A-Z]{2,4}$/.test(abbr)) {
        return abbr;
      }

      const knownZones: Record<string, string> = {
        'Asia/Kolkata': 'IST',
        'Asia/Calcutta': 'IST',
        'America/New_York': 'EST',
        'America/Los_Angeles': 'PST',
        'America/Chicago': 'CST',
        'America/Denver': 'MST',
        'Europe/London': 'GMT',
        'Europe/Paris': 'CET',
        'Europe/Berlin': 'CET',
        'Asia/Dubai': 'GST',
        'Asia/Tokyo': 'JST',
        'Australia/Sydney': 'AEDT',
        'Australia/Melbourne': 'AEDT',
      };

      return knownZones[browserTimeZone] || abbr || browserTimeZone;
    } catch {
      return 'UTC';
    }
  };

  const handleReschedule = async () => {
  try {
    setLoadingReschedule(true);

    if (isPanel) {
        // Panel no-slots email uses panel payload
        // await sendPanelRescheduleEmail(slot, candidateEmail, reschedulingReason);
      } else {

    // Build interviewer slots with validation
    const interviewerSlots = [
      {
        interviewer_email: slot?.pairing?.interviewer_1_id,
        interviewer_name: slot?.pairing?.interviewer_1_name,
        start_time: slot?.pairing?.interview_1_start_time 
          ? new Date(slot.pairing.interview_1_start_time).toISOString() 
          : null,
        end_time: slot?.pairing?.interview_1_end_time 
          ? new Date(slot.pairing.interview_1_end_time).toISOString() 
          : null,
      },
      {
        interviewer_email: slot?.pairing?.interviewer_2_id,
        interviewer_name: slot?.pairing?.interviewer_2_name,
        start_time: slot?.pairing?.interview_2_start_time 
          ? new Date(slot.pairing.interview_2_start_time).toISOString() 
          : null,
        end_time: slot?.pairing?.interview_2_end_time 
          ? new Date(slot.pairing.interview_2_end_time).toISOString() 
          : null,
      },
      {
        interviewer_email: slot?.pairing?.interviewer_3_id,
        interviewer_name: slot?.pairing?.interviewer_3_name,
        start_time: slot?.pairing?.interview_3_start_time 
          ? new Date(slot.pairing.interview_3_start_time).toISOString() 
          : null,
        end_time: slot?.pairing?.interview_3_end_time 
          ? new Date(slot.pairing.interview_3_end_time).toISOString() 
          : null,
      },
    ].filter(s => s.interviewer_email && s.interviewer_name);

    // If no alternate slots, send email and exit
    if (noAlternateRescheduleSlots) {
      await sendNoAlternateSlotsEmail({
        email_type: 'interview_reschedule',
        additional_data: {
          candidate_email: candidateEmail,
          candidate_name: slot.pairing.candidate_full_name,
          job_title: slot.job_title,
          interviewer_slots: interviewerSlots,
          interview_date: new Date(slot.pairing.start_time).toISOString().split('T')[0],
          recruiter_email: slot.pairing.recruiter_email,
          recruiter_name: slot.pairing.recruiter_name,
          reschedule_reason: reschedulingReason,
          send_to_candidate: false,
          send_to_interviewers: true,
          send_to_recruiter: true,
          campus_hire: isCampus,
          experienced_hire: isExperienced,
          
        },
      });
      setShowReschedulePopup(false);
      return;
    }
      
      // setShowReschedulePopup(false);
      // return;
    }

    // Alternate slots exist - go to calendar
setIsRescheduledClicked(true);
setSelectedDates([]);

// CRITICAL: Keep selectedSlot so parent knows which stage to show
// setSelectedSlot(null);  // DON'T clear this!

setShowReschedulePopup(false);

// For experienced candidates, make sure we pass the correct stage to refresh
 if (isPanel) {
      console.log('Panel candidate - refreshing pairings without clearing stage');
      clearPairingsCache();
      await refreshPairings();
    }
 else if (isExperienced && slot?.submission_group_id) {
  console.log('Keeping stage for reschedule:', slot.submission_group_id);
  clearPairingsCache();
  await refreshPairings(slot.submission_group_id);
  // Small delay to ensure state updates before showing calendar
  await new Promise(resolve => setTimeout(resolve, 100));
}

setSelectedPage('calendar');
  } catch (e) {
    console.error('Error switching to reschedule mode:', e);
  } finally {
    setLoadingReschedule(false);
  }
};

  const toLongDate = (ymd: string): JSX.Element | string => {
    if (!ymd) return ymd;

    const [year, month, day] = ymd.split('-').map(Number);
    const date = new Date(year, month - 1, day);

    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    const getOrdinalSuffix = (n: number): JSX.Element => {
      let suffix = 'th';
      if (n < 11 || n > 13) {
        switch (n % 10) {
          case 1:
            suffix = 'st';
            break;
          case 2:
            suffix = 'nd';
            break;
          case 3:
            suffix = 'rd';
            break;
        }
      }
      return <>{n}</>;
    };

    const weekday = weekdays[date.getDay()];
    const monthName = months[date.getMonth()];
    const dayWithSuffix = getOrdinalSuffix(date.getDate());

    return (
      <>
        {weekday}, {monthName} {dayWithSuffix}, {year}
      </>
    );
  };

  if (isRefreshing || !slot?.pairing) {
    return (
      <div className="main-popup-container">
        <div className="reschedule-cancel-popup-card">
          <div className="loading-container">
            <div className="spinner"></div>
            <span>Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  const dStart = new Date(slot.pairing.start_time);
  const dEnd = new Date(slot.pairing.end_time);
  const dateYMD = dStart.toLocaleDateString('en-CA', { timeZone: browserTimeZone });
  const startStr = dStart.toLocaleTimeString('en-US', {
    timeZone: browserTimeZone,
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
  const endStr = dEnd.toLocaleTimeString('en-US', {
    timeZone: browserTimeZone,
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
  const timeRange = `${startStr} – ${endStr}`;

  return (
    <div className="main-popup-container">
      <div className="reschedule-cancel-popup-card">
        <div className="popup-header">
          <div className="cancel-button-parent">
            <div
              className="close-button"
              onClick={() => {
                setShowReschedulePopup(false);
                setnoAlternateRescheduleSlots(false);
              }}
            >
              <Icons_Repository iconName="x" />
            </div>
          </div>
        </div>

        <div className="reschedule-cancel-section">
          <div className="reschedule-cancel-text-container">
            <div className="reschedule-cancel-text">
              Your interview is currently scheduled for the following time slot:
            </div>
            <div className="reschedule-cancel-text-date">
              <span>
                ({toLongDate(dateYMD)} at {timeRange} {getAbbreviation()})
              </span>
            </div>
            <textarea
                className="reschedule-cancel-reason withdraw-reason"
                placeholder="Please specify the reason for rescheduling the interview."
                value={reschedulingReason}
                onChange={(e) => setReschedulingReason(e.target.value)}
            />
          </div>
        </div>

        <div className="reschedule-cancel-buttons">
          <button
            className="reschedule-button"
            onClick={handleReschedule}
            disabled={loadingReschedule || reschedulingReason.trim().length === 0}
          >
            {loadingReschedule ? (
              <div className="loading-container">
                <div className="spinner"></div>
                <span>Rescheduling...</span>
              </div>
            ) : (
              'Yes, reschedule'
            )}
          </button>

          <button
            className="cancel-button"
            onClick={() => {
              setShowReschedulePopup(false);
              setnoAlternateRescheduleSlots(false);
            }}
            disabled={loadingReschedule}
          >
            Go back
          </button>
        </div>
      </div>
    </div>
  );
}

export default Component_Reschedule_Cancel_Popup;
